{
  "name": "Lostworld",
  "ambInd": "3",
  "skyDome": true,
  "skyDomeCol0": "#83b3b6",
  "skyDomeCol1": "#52756f",
  "skyDomeCol2": "#ffffff",
  "shadowR": 4096,
  "ambient": 12500670,
  "light": 13158600,
  "sky": 10007744,
  "fog": 7966360,
  "fogD": 1077.995864208168,
  "dthY": 75,
  "camPos": [-160, 131, -13],
  "spawns": [[301, 109, 12, 0, 3, 0], [-55, 115, -170, 0, 1, 0], [-55, 109, 76, 0, 1, 0], [101, 109, -48, 0, 0, 0], [-341, 92, -37, 0, 0, 0], [-208, 109, -58, 0, 0, 0], [107, 115, -107, 0, 3, 0], [266, 86, -102, 0, 0, 0], [-224, 109, 81, 0, 1, 0]],
  "modes": [0, 1],
  "ambO": 0.7,
  "ambS": 5,
  "shadLength": 1000,
  "shadWidth": 767,
  "skyDomeSize": 2000,
  "deathHeight": -100,
  "shadScale": 170,
  "objects": [{
    "p": [126, 145, -154],
    "s": [84, 4, 138],
    "f": [1, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [124, 89, -132],
    "s": [76, 20, 90],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-164, 99, -87],
    "s": [40, 10, 40],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-169, 99, -7],
    "s": [90, 10, 120],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-72, 59, -138],
    "s": [76, 56, 30],
    "f": [1, 1, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [121, 49, -23],
    "s": [506, 10, 450],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#374130",
    "t": 1
  }, {
    "p": [-274, 79, -274],
    "s": [120, 30, 80],
    "f": [0, 0, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-117, 59, -187],
    "s": [14, 86, 68],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-131, 144, -76],
    "s": [10, 4, 22],
    "l": 1,
    "r": [0, 0, -0.17],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-202, 59, -87],
    "s": [36, 78, 40],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [164, 89, -154],
    "s": [4, 56, 134],
    "f": [1, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [304, 59, -102],
    "s": [36, 50, 30],
    "f": [0, 1, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [104, 109, -94],
    "s": [36, 36, 14],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [157, 109, -94],
    "s": [10, 36, 14],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-79, 145, -134],
    "s": [94, 4, 178],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [311, 89, -147],
    "s": [50, 95, 60],
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-179, 144, -87],
    "s": [36, 4, 42],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [93, 115, -165],
    "s": [14, 30, 24],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [93, 115, -112],
    "s": [14, 30, 22],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [26, 112, -148],
    "s": [120, 1, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [26, 112, -128],
    "s": [120, 1, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [82, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [76, 113, -138],
    "s": [4, 1, 25],
    "pe": 1,
    "c": "#757575",
    "t": 2
  }, {
    "p": [70, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [64, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [58, 113, -137],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#727272",
    "t": 2
  }, {
    "p": [52, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [46, 113, -139],
    "s": [4, 1, 26],
    "pe": 1,
    "c": "#666666",
    "t": 2
  }, {
    "p": [40, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [34, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#727272",
    "t": 2
  }, {
    "p": [28, 113, -137],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [22, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#707070",
    "t": 2
  }, {
    "p": [16, 113, -138],
    "s": [4, 1, 26],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [10, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#454545",
    "t": 2
  }, {
    "p": [4, 113, -137],
    "s": [4, 1, 26],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-2, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#7a7a7a",
    "t": 2
  }, {
    "p": [-8, 113, -138],
    "s": [4, 1, 25],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-14, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-20, 113, -138],
    "s": [4, 1, 26],
    "pe": 1,
    "c": "#707070",
    "t": 2
  }, {
    "p": [-26, 113, -137],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-31, 113, -138],
    "s": [4, 1, 27],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [122, 109, -99],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [122, 109, -89],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [152, 109, -89],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [152, 109, -99],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [137, 144, -99],
    "s": [28, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [137, 144, -89],
    "s": [28, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [126, 141, -89],
    "s": [12, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [126, 141, -99],
    "s": [12, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [149, 140, -89],
    "s": [14, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [149, 140, -99],
    "s": [14, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [98, 109, -123],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [88, 109, -123],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [98, 109, -153],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [88, 109, -153],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [88, 144, -138],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [98, 144, -138],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [98, 141, -127],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [88, 141, -127],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [98, 141, -149],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [88, 141, -149],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 109, -153],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-36, 109, -153],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-36, 109, -123],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 109, -123],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-36, 144, -138],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 144, -138],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-36, 141, -127],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 141, -127],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 141, -149],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-36, 141, -149],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-107, 109, -54],
    "s": [6, 36, 14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-61, 109, -54],
    "s": [26, 36, 14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-184, 109, -70],
    "s": [2, 35, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-184, 109, -104],
    "s": [2, 35, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-184, 109, -87],
    "s": [2, 35, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, -87],
    "s": [2, 35, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, -70],
    "s": [2, 35, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, -104],
    "s": [2, 35, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 143, -70],
    "s": [38, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 142, -87],
    "s": [38, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 142, -104],
    "s": [38, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-176, 138, -104],
    "s": [20, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-151, 137, -104],
    "s": [20, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-151, 137, -87],
    "s": [20, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-151, 137, -70],
    "s": [20, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-176, 138, -87],
    "s": [20, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-176, 138, -70],
    "s": [20, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-14, 49, 158],
    "s": [20, 30, 70],
    "f": [1, 0, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [22, 52, 203],
    "s": [52, 30, 20],
    "f": [0, 0, 0, 0, 0, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [22, 52, 169],
    "s": [52, 30, 48],
    "f": [0, 0, 0, 0, 0, 1],
    "c": "#000000",
    "o": 0.8,
    "t": 5
  }, {
    "p": [26, 66, -19],
    "s": [600, 10, 600],
    "l": 1,
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#212e23",
    "o": 0.61,
    "t": 5
  }, {
    "p": [-179, 136, -70],
    "s": [8, 2, 2],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-149, 136, -70],
    "s": [8, 2, 2],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-149, 136, -104],
    "s": [8, 2, 2],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-179, 136, -104],
    "s": [8, 2, 2],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [339, 113, -71],
    "s": [34, 24, 90],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [361, 113, -36],
    "s": [10, 24, 20],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [361, 113, -71],
    "s": [10, 24, 20],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [361, 113, -106],
    "s": [10, 24, 20],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [352, 117, -71],
    "s": [20, 20, 60],
    "f": [1, 0, 0, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [344, 137, -71],
    "s": [50, 4, 96],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [311, 182, -147],
    "s": [54, 4, 64],
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-179, 148, -87],
    "s": [34, 8, 40],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11,
    "bo": 1
  }, {
    "p": [-79, 149, -134],
    "s": [90, 10, 174],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-79, 159, -134],
    "s": [94, 4, 178],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-34, 109, 178],
    "s": [20, 41, 10],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-27, 109, 150],
    "s": [2, 26, 15],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-34, 135, 158],
    "s": [20, 15, 30],
    "f": [1, 1, 1, 1, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-34, 109, 99],
    "s": [20, 41, 88],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-114, 109, 101],
    "s": [20, 41, 12],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 133, 215],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 139, 217],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 145, 219],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 151, 221],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 157, 223],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 163, 225],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 169, 227],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 175, 229],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 181, 231],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 187, 233],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 193, 235],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [93, 101, 202],
    "s": [14, 120, 40],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [49, 102, 201],
    "s": [14, 120, 40],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [115, 109, 208],
    "s": [30, 12, 30],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [71, 109, 250],
    "s": [130, 60, 80],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [146, 109, 263],
    "s": [20, 46, 80],
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-4, 109, 263],
    "s": [20, 46, 80],
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [71, 109, 266],
    "s": [86, 104, 70],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 169, 261],
    "s": [110, 22, 80],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 209, 262],
    "s": [60, 26, 60],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [206, 109, -27],
    "s": [140, 30, 20],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [113, 109, -20],
    "s": [15, 26, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [121, 135, -27],
    "s": [30, 4, 20],
    "f": [0, 0, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-179, 156, -87],
    "s": [36, 4, 42],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-145, 147, -87],
    "s": [28, 8, 40],
    "r": [0, 0, 0.17],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11,
    "bo": 1
  }, {
    "p": [-134, 59, -87],
    "s": [20, 85, 40],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [181, 139, -27],
    "s": [194, 4, 24],
    "f": [1, 0, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [179, 143, -27],
    "s": [186, 14, 20],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [178, 157, -27],
    "s": [184, 4, 24],
    "f": [1, 0, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [68, 49, 158],
    "s": [40, 30, 70],
    "f": [0, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [126, 159, -154],
    "s": [84, 4, 138],
    "f": [1, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [26, 145, -198],
    "s": [116, 4, 50],
    "f": [1, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [84, 59, -84],
    "s": [4, 132, 26],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11,
    "bo": 1
  }, {
    "p": [183, 109, -85],
    "s": [48, 6, 4],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [261, 109, -85],
    "s": [50, 6, 4],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [87, 138, -73],
    "s": [2, 36, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.87],
    "c": "#505050",
    "t": 2
  }, {
    "p": [87, 138, -47],
    "s": [2, 36, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.87],
    "c": "#505050",
    "t": 2
  }, {
    "p": [70, 160, -73],
    "s": [30, 2, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [70, 160, -47],
    "s": [30, 2, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [137, 109, -97],
    "s": [30, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [137, 111, -99],
    "s": [30, 2, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-81, 59, -92],
    "s": [66, 56, 62],
    "f": [0, 0, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [88, 109, 76],
    "s": [4, 6, 102],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 143, 11],
    "s": [130, 14, 56],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-195, 137, -87],
    "s": [22, 7, 40],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [21, 89, 31],
    "s": [130, 26, 12],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [78, 115, 31],
    "s": [10, 24, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-36, 115, 31],
    "s": [10, 24, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 139, 11],
    "s": [134, 4, 60],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [40, 115, 31],
    "s": [10, 24, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [2, 115, 31],
    "s": [10, 24, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 89, 4],
    "s": [130, 20, 42],
    "f": [0, 0, 1, 1, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [22, 53, 126],
    "s": [1, 28, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [16, 53, 126],
    "s": [1, 22, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [10, 53, 126],
    "s": [1, 13, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [4, 53, 126],
    "s": [1, 28, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [-2, 53, 126],
    "s": [1, 28, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [28, 53, 126],
    "s": [1, 28, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [34, 53, 126],
    "s": [1, 28, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [40, 71, 126],
    "s": [1, 9, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [46, 53, 126],
    "s": [1, 28, 1],
    "c": "#000000",
    "t": 5
  }, {
    "p": [-74, 59, 212],
    "s": [100, 91, 58],
    "f": [1, 0, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-114, 59, 168],
    "s": [20, 91, 30],
    "f": [1, 0, 0, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-104, 109, -49],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-104, 109, -59],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-74, 109, -49],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-74, 109, -59],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-89, 144, -59],
    "s": [28, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-89, 144, -49],
    "s": [28, 2, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-196, 109, -223],
    "s": [28, 1, 46],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-197, 109, -120],
    "s": [26, 1, 26],
    "l": 1,
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-216, 105, -184],
    "s": [4, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-127, 109, -193],
    "s": [26, 1, 70],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-299, 105, 11],
    "s": [34, 2, 4],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-194, 109, 87],
    "s": [20, 40, 40],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-194, 109, 145],
    "s": [20, 40, 16],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-201, 109, 130],
    "s": [2, 26, 15],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 149, 87],
    "s": [80, 5, 40],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-164, 149, 160],
    "s": [80, 5, 46],
    "f": [0, 1, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-154, 154, 143],
    "s": [88, 5, 20],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-154, 154, 101],
    "s": [88, 5, 20],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-154, 159, 105],
    "s": [84, 5, 20],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-154, 159, 139],
    "s": [84, 5, 20],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-194, 135, 122],
    "s": [20, 29, 30],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-303, 88, 186],
    "s": [120, 69, 60],
    "f": [1, 0, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [84, 59, -36],
    "s": [4, 132, 26],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11,
    "bo": 1
  }, {
    "p": [-89, 109, -57],
    "s": [30, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-89, 111, -59],
    "s": [30, 2, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-18, 160, -47],
    "s": [30, 2, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-18, 160, -73],
    "s": [30, 2, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-8, 161, -73],
    "s": [2, 36, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 2.27],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-8, 161, -47],
    "s": [2, 36, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 2.27],
    "c": "#505050",
    "t": 2
  }, {
    "p": [56, 143, -73],
    "s": [1, 17, 1],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [56, 137, -47],
    "s": [1, 23, 1],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-73, 150, 79],
    "s": [102, 4, 52],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-34, 150, 142],
    "s": [24, 4, 74],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-42, 154, 141],
    "s": [22, 4, 58],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-74, 154, 202],
    "s": [86, 4, 64],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-74, 154, 100],
    "s": [86, 4, 24],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-106, 154, 141],
    "s": [22, 4, 58],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-104, 150, 142],
    "s": [4, 4, 74],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-74, 158, 104],
    "s": [70, 4, 32],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-74, 158, 178],
    "s": [70, 4, 32],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-50, 158, 141],
    "s": [22, 4, 42],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-98, 158, 141],
    "s": [22, 4, 42],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-205, 109, -7],
    "s": [30, 1, 120],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-125, 109, -60],
    "s": [32, 1, 46],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [71, 162, -60],
    "s": [4, 1, 30],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [64, 162, -61],
    "s": [4, 1, 30],
    "pe": 1,
    "r": [0, 0.17, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [56, 162, -60],
    "s": [4, 1, 30],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [55, 133, -57],
    "s": [1, 4, 30],
    "l": 1,
    "r": [-0.52, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-15, 162, -60],
    "s": [4, 1, 30],
    "pe": 1,
    "r": [0, -0.17, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [344, 99, -71],
    "s": [46, 18, 92],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [340, 59, -147],
    "s": [24, 31, 41],
    "f": [0, 1, 0, 0, 0, 0],
    "c": "#000000",
    "t": 5
  }, {
    "p": [344, 141, -71],
    "s": [46, 10, 92],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [311, 49, -172],
    "s": [50, 40, 10],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [311, 49, -122],
    "s": [50, 40, 10],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [167, 109, 122],
    "s": [20, 28, 280],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [266, 109, 53],
    "s": [20, 33, 140],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-361, 109, -37],
    "s": [22, 26, 500],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 2
  }, {
    "p": [435, 95, -67],
    "s": [162, 28, 220],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [367, 96, 43],
    "s": [196, 2, 5],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [352, 96, 4],
    "s": [10, 2, 66],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [163, 106, 111],
    "s": [6, 2, 255],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [27, 109, 208],
    "s": [30, 12, 30],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-156, 109, 71],
    "s": [66, 40, 38],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [300, 109, -63],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": 0
  }, {
    "p": [-299, 91, -55],
    "s": [24, 36, 24],
    "i": 23,
    "l": 1,
    "tm": "1"
  }, {
    "p": [-234, 111, -112],
    "s": [30, 24, 20],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 111, -35],
    "s": [30, 24, 20],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 111, 42],
    "s": [30, 24, 20],
    "f": [1, 1, 0, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 111, 3],
    "s": [30, 24, 20],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 111, -73],
    "s": [30, 24, 20],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 135, -35],
    "s": [30, 12, 174],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 147, -35],
    "s": [38, 4, 178],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-234, 151, -35],
    "s": [34, 12, 174],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-234, 163, -35],
    "s": [38, 4, 178],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [54, 121, -11],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [54, 109, -11],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-234, 111, -35],
    "s": [24, 24, 140],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-248, 111, -103],
    "s": [6, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 111, -81],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 111, -65],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 111, -43],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 111, -27],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 111, -5],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 111, 11],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-248, 111, 32],
    "s": [6, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-250, 135, -92],
    "s": [3, 4, 28],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-250, 135, -54],
    "s": [3, 4, 28],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-250, 135, -16],
    "s": [3, 4, 28],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-250, 135, 22],
    "s": [3, 4, 28],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-284, 88, 83],
    "s": [160, 21, 140],
    "f": [0, 0, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-219, 109, 62],
    "s": [60, 38, 20],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-220, 147, 64],
    "s": [66, 4, 20],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-201, 147, 52],
    "s": [28, 4, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-221, 151, 62],
    "s": [60, 12, 20],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-223, 163, 64],
    "s": [60, 4, 20],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-204, 163, 52],
    "s": [22, 4, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-204, 109, -249],
    "s": [400, 36, 26],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 3
  }, {
    "p": [-352, 106, 5],
    "s": [5, 2, 340],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [-114, 109, 145],
    "s": [20, 41, 16],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [129, 144, -138],
    "s": [4, 1, 3],
    "c": "#000000",
    "t": 5
  }, {
    "p": [129, 143, -138],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#ffe9a6",
    "t": 5
  }, {
    "p": [-79, 144, -150],
    "s": [4, 1, 3],
    "c": "#000000",
    "t": 5
  }, {
    "p": [-79, 143, -150],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#ffe9a6",
    "t": 5
  }, {
    "p": [-490, 159, -55],
    "s": [120, 10, 120],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 169, -55],
    "s": [100, 10, 100],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 179, -55],
    "s": [80, 10, 80],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 189, -55],
    "s": [60, 10, 60],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 199, -55],
    "s": [40, 10, 40],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 169, -55],
    "s": [110, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 179, -55],
    "s": [90, 5, 24],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 189, -55],
    "s": [70, 5, 24],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 199, -55],
    "s": [50, 5, 24],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 209, -55],
    "s": [20, 5, 20],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-490, 159, -55],
    "s": [130, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [201, 109, -45],
    "s": [80, 1, 18],
    "l": 1,
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [154, 109, -43],
    "s": [14, 1, 12],
    "l": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-26, 154, 148],
    "s": [4, 14, 186],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-26, 168, 148],
    "s": [8, 4, 190],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [413, 54, -202],
    "s": [200, 102, 50],
    "f": [0, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [311, 196, -147],
    "s": [54, 4, 64],
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [413, 156, -202],
    "s": [204, 4, 54],
    "f": [0, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [230, 114, -206],
    "s": [180, 2, 50],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [129, 109, 187],
    "s": [70, 1, 24],
    "l": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [8, 109, 193],
    "s": [70, 1, 20],
    "l": 1,
    "f": [0, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [144, 109, 186],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [37, 109, 133],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [25, 109, 133],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-220, 111, 32],
    "s": [6, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 111, 11],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 135, 22],
    "s": [3, 4, 28],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-218, 111, -5],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 111, -43],
    "s": [2, 23, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 111, -65],
    "s": [2, 19, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 111, -27],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 135, -16],
    "s": [3, 4, 28],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-218, 133, -53],
    "s": [3, 4, 28],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-246, 109, 61],
    "s": [60, 1, 80],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-209, 109, 87],
    "s": [14, 1, 34],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-148, 78, -238],
    "s": [500, 2, 5],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [-121, 78, -246],
    "s": [5, 2, 50],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [-74, 162, 167],
    "s": [46, 1, 10],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-74, 151, 162],
    "s": [2, 12, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-68, 154, 162],
    "s": [1, 9, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-81, 155, 162],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-77, 156, 162],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-79, 160, 162],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-71, 161, 162],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-63, 156, 162],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-66, 157, 162],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-65, 160, 162],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-80, 143, 120],
    "s": [2, 20, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-74, 162, 115],
    "s": [46, 1, 10],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-69, 155, 120],
    "s": [1, 8, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-65, 153, 120],
    "s": [2, 10, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-67, 157, 120],
    "s": [3, 6, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-74, 153, 120],
    "s": [1, 10, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-76, 156, 120],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-75, 160, 120],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-85, 156, 120],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-84, 159, 120],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-82, 161, 120],
    "s": [3, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-106, 109, 137],
    "s": [2, 27, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 109, 137],
    "s": [2, 27, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 109, 107],
    "s": [2, 27, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-106, 109, 107],
    "s": [2, 27, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 134, 122],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-106, 134, 122],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-92, 162, 141],
    "s": [10, 1, 42],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-56, 162, 141],
    "s": [10, 1, 42],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-84, 158, 162],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-72, 159, 120],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-62, 159, 120],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-122, 130, 110],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-106, 130, 110],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-106, 130, 134],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 130, 134],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [413, 170, -202],
    "s": [204, 4, 54],
    "f": [0, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-209, 141, -74],
    "s": [10, 6, 10],
    "l": 1,
    "r": [0, 0, 0.69],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-61, 156, 128],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 152, 132],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 153, 152],
    "s": [1, 10, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 157, 155],
    "s": [1, 6, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 160, 149],
    "s": [1, 3, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 157, 139],
    "s": [1, 6, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 161, 137],
    "s": [1, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 155, 135],
    "s": [1, 8, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 159, 144],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 160, 124],
    "s": [1, 3, 7],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 156, 160],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-61, 161, 158],
    "s": [1, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 156, 151],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 152, 132],
    "s": [1, 11, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 155, 134],
    "s": [1, 8, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 160, 129],
    "s": [1, 3, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 159, 126],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 148, 147],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 161, 145],
    "s": [1, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 160, 140],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 160, 136],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-87, 160, 157],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-154, 164, 111],
    "s": [70, 1, 8],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-154, 164, 133],
    "s": [70, 1, 8],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-133, 156, 129],
    "s": [1, 9, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-146, 157, 129],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-142, 158, 129],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-144, 162, 129],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-135, 163, 129],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-128, 158, 129],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-130, 162, 129],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-149, 160, 129],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-165, 153, 129],
    "s": [2, 12, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-159, 156, 129],
    "s": [1, 9, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-172, 157, 129],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-168, 158, 129],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-170, 162, 129],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-162, 163, 129],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-154, 158, 129],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-156, 162, 129],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-175, 160, 129],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-163, 156, 115],
    "s": [1, 9, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-176, 157, 115],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-172, 158, 115],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-174, 162, 115],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-166, 163, 115],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-158, 158, 115],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-160, 162, 115],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-179, 160, 115],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-137, 153, 115],
    "s": [2, 12, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-131, 156, 115],
    "s": [1, 9, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-144, 157, 115],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-140, 158, 115],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-142, 162, 115],
    "s": [3, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-134, 163, 115],
    "s": [4, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-126, 158, 115],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-128, 162, 115],
    "s": [6, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-147, 160, 115],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-154, 153, 115],
    "s": [2, 12, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-152, 160, 115],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-180, 156, 129],
    "s": [1, 9, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-282, 109, 163],
    "s": [180, 26, 20],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 1
  }, {
    "p": [-228, 95, 223],
    "s": [240, 40, 100],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-250, 106, 155],
    "s": [92, 2, 5],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [-344, 109, 124],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-332, 109, 126],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-268, 109, 30],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [328, 116, -238],
    "s": [30, 28, 50],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [55, 136, -320],
    "s": [780, 42, 36],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 3
  }, {
    "p": [-389, 135, 155],
    "s": [6, 44, 6],
    "pe": 1,
    "f": [1, 0, 0, 0, 0, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-389, 158, 148],
    "s": [2, 2, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-377, 147, 155],
    "s": [10, 10, 10],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-382, 150, 155],
    "s": [10, 2, 2],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-388, 154, 142],
    "s": [10, 10, 10],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-389, 173, 155],
    "s": [60, 34, 50],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 0, 1, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-426, 156, 114],
    "s": [20, 13, 17],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-419, 151, 80],
    "s": [20, 13, 17],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-414, 147, 99],
    "s": [20, 13, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-411, 139, 123],
    "s": [20, 16, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-419, 148, 136],
    "s": [20, 16, 17],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-418, 144, -136],
    "s": [20, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-425, 149, -122],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-457, 153, 52],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-436, 148, 19],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-424, 147, -151],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [182, 135, 250],
    "s": [8, 44, 8],
    "pe": 1,
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [182, 169, 247],
    "s": [78, 48, 78],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 0, 1, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-487, 93, 178],
    "s": [90, 104, 180],
    "f": [1, 0, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-487, 183, 178],
    "s": [94, 4, 184],
    "f": [1, 0, 0, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-487, 197, 178],
    "s": [94, 4, 184],
    "f": [1, 0, 0, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [517, 121, -171],
    "s": [8, 64, 8],
    "pe": 1,
    "f": [0, 1, 0, 0, 1, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [517, 179, -171],
    "s": [76, 50, 76],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 0, 1, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [315, 133, -257],
    "s": [24, 30, 24],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [292, 123, -268],
    "s": [24, 30, 24],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [231, 114, -244],
    "s": [300, 30, 30],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 3
  }, {
    "p": [361, 122, 26],
    "s": [1, 33, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [371, 122, 26],
    "s": [1, 33, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [371, 122, 6],
    "s": [1, 33, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [361, 122, 6],
    "s": [1, 37, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [361, 122, -4],
    "s": [1, 33, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [371, 122, -4],
    "s": [1, 42, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [366, 151, 11],
    "s": [12, 1, 32],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [366, 146, -5],
    "s": [12, 1, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [366, 141, -5],
    "s": [12, 1, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [366, 136, -5],
    "s": [12, 1, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [366, 131, -5],
    "s": [12, 1, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [366, 139, 16],
    "s": [12, 1, 22],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-410, 140, 54],
    "s": [6, 44, 6],
    "pe": 1,
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-410, 177, 54],
    "s": [62, 38, 62],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 0, 1, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-299, 91, -5],
    "s": [32, 18, 36],
    "i": 9,
    "v": 1,
    "c": "#a7a793",
    "d": 1
  }, {
    "p": [-299, 103, 9],
    "s": [34, 2, 8],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 101, 7],
    "s": [34, 2, 12],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 99, 5],
    "s": [34, 2, 16],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 97, 3],
    "s": [34, 2, 20],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 95, 1],
    "s": [34, 2, 24],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 93, -1],
    "s": [34, 2, 28],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 91, -3],
    "s": [34, 2, 32],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 103, -184],
    "s": [8, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-220, 101, -184],
    "s": [12, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-222, 99, -184],
    "s": [16, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-224, 97, -184],
    "s": [20, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-226, 95, -184],
    "s": [24, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-228, 93, -184],
    "s": [28, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-230, 91, -184],
    "s": [32, 2, 34],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-89, 109, -54],
    "s": [30, 6, 14],
    "i": 9,
    "v": 1,
    "c": "#a7a793",
    "d": 3
  }, {
    "p": [335, 117, -238],
    "s": [24, 30, 24],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-240, 134, -327],
    "s": [7, 80, 7],
    "pe": 1,
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 176, -298],
    "s": [74, 42, 74],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-25, 162, -60],
    "s": [4, 1, 30],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-4, 151, -47],
    "s": [1, 9, 1],
    "l": 1,
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-6, 151, -66],
    "s": [4, 1, 30],
    "l": 1,
    "r": [1.05, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [254, 109, -44],
    "s": [26, 1, 14],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-79, 144, -82],
    "s": [4, 1, 3],
    "c": "#000000",
    "t": 5
  }, {
    "p": [-79, 143, -82],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#ffe9a6",
    "t": 5
  }, {
    "p": [-188, 109, -22],
    "s": [4, 1, 54],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [97, 59, -86],
    "s": [22, 32, 22],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-84, 59, -180],
    "s": [74, 56, 54],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-247, 91, -77],
    "s": [70, 1, 180],
    "l": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-261, 91, -236],
    "s": [110, 1, 70],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-201, 109, -144],
    "s": [18, 1, 22],
    "l": 1,
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-397, 156, 54],
    "s": [20, 4, 4],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-389, 160, 54],
    "s": [4, 4, 4],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-387, 163, 54],
    "s": [22, 10, 14],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [546, 140, 80],
    "s": [8, 70, 8],
    "pe": 1,
    "f": [0, 1, 0, 0, 0, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [546, 186, 80],
    "s": [86, 52, 86],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 0, 1, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [82, 94, -60],
    "s": [1, 4, 30],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#939393",
    "t": 2
  }, {
    "p": [82, 86, -60],
    "s": [1, 4, 30],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-173, 119, 233],
    "s": [60, 30, 100],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [98, 109, 86],
    "s": [20, 1, 60],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [96, 109, 121],
    "s": [14, 1, 10],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [152, 109, 155],
    "s": [16, 1, 40],
    "l": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [155, 109, 120],
    "s": [12, 1, 30],
    "l": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-13, 111, 253],
    "s": [900, 64, 78],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 1
  }, {
    "p": [541, 123, -59],
    "s": [50, 40, 398],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [566, 147, -205],
    "s": [30, 30, 30],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [576, 144, -180],
    "s": [30, 30, 30],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [566, 136, -162],
    "s": [30, 30, 30],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [541, 127, 93],
    "s": [40, 40, 40],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [572, 135, 60],
    "s": [40, 40, 40],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-337, 109, 105],
    "s": [40, 1, 120],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-345, 109, 35],
    "s": [40, 1, 20],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [398, 144, -310],
    "s": [40, 30, 44],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [541, 121, -251],
    "s": [60, 40, 40],
    "l": 1,
    "pe": 1,
    "f": [0, 0, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [141, 106, 224],
    "s": [59, 2, 5],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [480, 136, -289],
    "s": [120, 60, 100],
    "f": [0, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [480, 210, -289],
    "s": [124, 4, 104],
    "f": [0, 1, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [480, 196, -289],
    "s": [124, 4, 104],
    "f": [0, 1, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 155, -308],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 161, -310],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 167, -312],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 173, -314],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 179, -316],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 185, -318],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 191, -320],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 197, -322],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 203, -324],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 209, -326],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 215, -328],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 221, -330],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 137, -358],
    "s": [130, 60, 80],
    "r": [-3.14, 0, -3.14],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [143, 137, -358],
    "s": [20, 40, 80],
    "r": [-3.14, 0, -3.14],
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [293, 137, -358],
    "s": [20, 40, 80],
    "r": [-3.14, 0, -3.14],
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 140, -360],
    "s": [64, 100, 70],
    "r": [-3.14, 0, -3.14],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 197, -358],
    "s": [100, 20, 60],
    "r": [-3.14, 0, -3.14],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 237, -363],
    "s": [40, 20, 50],
    "r": [-3.14, 0, -3.14],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [260, 137, -307],
    "s": [30, 30, 30],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 137, -303],
    "s": [62, 26, 29],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [241, 132, -292],
    "s": [16, 102, 40],
    "l": 1,
    "r": [2.79, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [195, 132, -292],
    "s": [16, 102, 40],
    "l": 1,
    "r": [2.79, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 149, -306],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 143, -304],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 137, -302],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [134, 130, -284],
    "s": [6, 44, 6],
    "pe": 1,
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [134, 172, -284],
    "s": [60, 38, 60],
    "l": 1,
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [363, 149, -336],
    "s": [40, 40, 44],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [276, 104, -284],
    "s": [400, 40, 50],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-99, 141, -49],
    "s": [12, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-99, 141, -59],
    "s": [12, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-78, 140, -49],
    "s": [14, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-78, 140, -59],
    "s": [14, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.7],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-176, 109, -227],
    "s": [12, 1, 34],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [93, 109, 47],
    "s": [7, 1, 18],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-114, 135, 122],
    "s": [20, 29, 30],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-301, 109, 155],
    "s": [32, 1, 20],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-432, 109, -55],
    "s": [120, 26, 600],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [32, 109, 125],
    "s": [37, 6, 4],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [91, 161, -33],
    "s": [10, 30, 32],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [89, 191, -107],
    "s": [18, 4, 172],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [91, 161, -131],
    "s": [10, 30, 120],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-39, 109, -33],
    "s": [10, 82, 32],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [22, 191, -20],
    "s": [100, 4, 10],
    "f": [1, 0, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [89, 195, -109],
    "s": [14, 10, 164],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [89, 205, -115],
    "s": [18, 4, 156],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [19, 195, -20],
    "s": [98, 10, 6],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [19, 205, -20],
    "s": [94, 4, 10],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-32, 59, -84],
    "s": [4, 132, 26],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11,
    "bo": 1
  }, {
    "p": [-32, 59, -36],
    "s": [4, 132, 26],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11,
    "bo": 1
  }, {
    "p": [-39, 161, -131],
    "s": [10, 30, 120],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-37, 191, -104],
    "s": [18, 4, 178],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-37, 205, -104],
    "s": [18, 4, 178],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-37, 195, -104],
    "s": [14, 10, 174],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-30, 168, -60],
    "s": [1, 4, 26],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-30, 185, -60],
    "s": [1, 4, 26],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-30, 177, -60],
    "s": [1, 4, 26],
    "pe": 1,
    "r": [0.17, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-350, 88, -57],
    "s": [4, 21, 140],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-364, 133, -172],
    "s": [10, 50, 10],
    "pe": 1,
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-364, 174, -172],
    "s": [110, 58, 110],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 0, 1, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [85, 161, 1],
    "s": [13, 5, 7],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 183, -20],
    "s": [110, 8, 6],
    "f": [1, 0, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-46, 144, 256],
    "s": [8, 44, 8],
    "pe": 1,
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-46, 179, 256],
    "s": [62, 40, 62],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 0, 1, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [71, 235, 264],
    "s": [34, 16, 50],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 199, 237],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [218, 227, -332],
    "s": [30, 6, 50],
    "r": [-3.14, 0, -3.14],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-138, 144, -103],
    "s": [6, 4, 10],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 167, -81],
    "s": [26, 22, 26],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-240, 189, -89],
    "s": [14, 10, 10],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-229, 187, -84],
    "s": [8, 6, 12],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-220, 171, -58],
    "s": [12, 4, 12],
    "l": 1,
    "r": [0.87, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 167, -65],
    "s": [26, 12, 6],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 167, 37],
    "s": [32, 8, 42],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-234, 175, 42],
    "s": [30, 4, 32],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-243, 167, -2],
    "s": [8, 6, 12],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-41, 59, -187],
    "s": [14, 86, 68],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [5, 59, -177],
    "s": [18, 86, 4],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [47, 59, -177],
    "s": [18, 86, 4],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-34, 88, -159],
    "s": [2, 34, 8],
    "i": 3,
    "c": "#505050",
    "t": 2
  }, {
    "p": [26, 89, -20],
    "s": [120, 94, 6],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [91, 109, -62],
    "s": [10, 52, 50],
    "f": [1, 1, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [55, 154, -60],
    "s": [1, 4, 30],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [55, 147, -60],
    "s": [1, 4, 30],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [96, 109, -27],
    "s": [20, 30, 20],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [82, 103, -60],
    "s": [1, 4, 30],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [82, 112, -60],
    "s": [1, 4, 30],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#7c7c7c",
    "t": 2
  }, {
    "p": [124, 109, -139],
    "s": [76, 6, 76],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-164, 99, 103],
    "s": [80, 10, 100],
    "f": [0, 0, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-29, 103, -138],
    "s": [10, 8, 22],
    "f": [1, 0, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [81, 103, -138],
    "s": [10, 8, 22],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-38, 98, -138],
    "s": [10, 14, 20],
    "l": 1,
    "r": [0, 0, -0.87],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [90, 98, -138],
    "s": [10, 14, 20],
    "l": 1,
    "r": [0, 0, 0.87],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [137, 109, -94],
    "s": [30, 6, 14],
    "i": 9,
    "v": 1,
    "c": "#a7a793",
    "d": 3
  }, {
    "p": [-74, 59, 119],
    "s": [100, 50, 128],
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-84, 59, -8],
    "s": [80, 50, 90],
    "f": [0, 0, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-77, 59, 46],
    "s": [86, 50, 18],
    "f": [1, 0, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-66, 109, 62],
    "s": [44, 41, 14],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-128, 109, 51],
    "s": [1, 64, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-128, 109, 41],
    "s": [1, 62, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-141, 152, 46],
    "s": [30, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2,
    "bo": 1
  }, {
    "p": [-155, 109, 41],
    "s": [1, 62, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-155, 109, 51],
    "s": [1, 62, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-171, 135, 46],
    "s": [34, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2,
    "bo": 1
  }, {
    "p": [-187, 109, 41],
    "s": [1, 42, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-187, 109, 51],
    "s": [1, 42, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-154, 147, 46],
    "s": [1, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-129, 131, 46],
    "s": [1, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2,
    "bo": 1
  }, {
    "p": [-129, 163, 46],
    "s": [1, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-156, 157, 46],
    "s": [1, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-186, 143, 46],
    "s": [1, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-157, 109, 42],
    "s": [66, 1, 24],
    "l": 1,
    "f": [0, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-117, 109, 75],
    "s": [14, 41, 40],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-56, 109, -37],
    "s": [28, 1, 24],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-117, 109, 45],
    "s": [14, 26, 20],
    "f": [1, 1, 0, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-104, 109, 32],
    "s": [40, 27, 6],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-104, 135, 45],
    "s": [42, 4, 36],
    "f": [1, 1, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-86, 109, 35],
    "s": [2, 27, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-86, 109, 55],
    "s": [2, 27, 2],
    "l": 1,
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-86, 134, 45],
    "s": [2, 2, 18],
    "l": 1,
    "f": [1, 1, 1, 1, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-86, 131, 52],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "f": [1, 1, 1, 1, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-86, 131, 38],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "f": [1, 1, 1, 1, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-98, 134, 45],
    "s": [4, 1, 3],
    "c": "#000000",
    "t": 5
  }, {
    "p": [-98, 133, 45],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#ffe9a6",
    "t": 5
  }, {
    "p": [-73, 154, 57],
    "s": [90, 14, 4],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-72, 168, 57],
    "s": [84, 4, 8],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-116, 109, 26],
    "s": [34, 1, 8],
    "l": 1,
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-83, 130, 35],
    "s": [1, 10, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-83, 125, 33],
    "s": [1, 15, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-24, 59, 81],
    "s": [2, 91, 18],
    "f": [1, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [21, 157, 11],
    "s": [134, 4, 60],
    "f": [1, 1, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-30, 86, -60],
    "s": [1, 4, 30],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-30, 96, -61],
    "s": [1, 4, 30],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#7a7a7a",
    "t": 2
  }, {
    "p": [-30, 110, -60],
    "s": [1, 4, 30],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-184, 109, -234],
    "s": [1, 54, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-79, 115, -119],
    "s": [57, 28, 110],
    "i": 14,
    "l": 1
  }, {
    "p": [35, 109, 165],
    "s": [113, 49, 73],
    "i": 14,
    "l": 1
  }, {
    "p": [-125, 109, 153],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-183, 109, 153],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, 153],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 109, 153],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-183, 109, 90],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 109, 90],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, 90],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-125, 109, 90],
    "s": [2, 40, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 135, 156],
    "s": [1, 20, 2],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-125, 135, 156],
    "s": [1, 20, 2],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 135, 156],
    "s": [1, 20, 2],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-183, 135, 156],
    "s": [1, 20, 2],
    "l": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-183, 138, 90],
    "s": [1, 20, 2],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 138, 90],
    "s": [1, 20, 2],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 138, 90],
    "s": [1, 20, 2],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-125, 138, 90],
    "s": [1, 20, 2],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-85, 109, 30],
    "s": [3, 27, 3],
    "l": 1,
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-123, 109, 30],
    "s": [3, 27, 3],
    "l": 1,
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-88, 139, 33],
    "s": [9, 1, 12],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-83, 134, 27],
    "s": [1, 6, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-83, 137, 29],
    "s": [1, 3, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [71, 205, 239],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 211, 241],
    "s": [30, 6, 50],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 217, 243],
    "s": [30, 6, 50],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 223, 245],
    "s": [30, 6, 50],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-368, 91, -223],
    "s": [96, 30, 200],
    "f": [1, 0, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [96, 142, -56],
    "s": [1, 20, 1],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [96, 144, -64],
    "s": [1, 18, 1],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [97, 158, -60],
    "s": [1, 2, 10],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [94, 161, -56],
    "s": [5, 1, 1],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [94, 161, -64],
    "s": [5, 1, 1],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [97, 151, -60],
    "s": [1, 2, 10],
    "l": 1,
    "r": [-0.09, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [204, 59, 53],
    "s": [236, 50, 280],
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [31, 79, 158],
    "s": [110, 30, 70],
    "f": [0, 0, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-154, 141, 46],
    "s": [1, 1, 12],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-7, 109, 209],
    "s": [44, 10, 30],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 1
  }, {
    "p": [93, 109, 210],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [93, 115, 212],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [93, 121, 214],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [93, 127, 217],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [49, 127, 216],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [49, 121, 213],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [49, 115, 211],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [49, 109, 209],
    "s": [14, 6, 50],
    "v": 1,
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [71, 127, 213],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [71, 121, 211],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 115, 209],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 109, 207],
    "s": [30, 6, 50],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [161, 109, 227],
    "s": [62, 28, 60],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 1
  }, {
    "p": [119, 125, 197],
    "s": [4, 14, 4],
    "r": [0.17, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [113, 125, 202],
    "s": [4, 14, 4],
    "r": [-0.17, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [116, 139, 200],
    "s": [10, 14, 6],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [116, 153, 200],
    "s": [7, 7, 7],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [122, 149, 201],
    "s": [3, 8, 4],
    "l": 1,
    "r": [-0.69, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [122, 154, 196],
    "s": [3, 8, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [30, 125, 198],
    "s": [4, 14, 4],
    "r": [0.17, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [24, 125, 202],
    "s": [4, 14, 4],
    "r": [-0.17, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [27, 139, 200],
    "s": [10, 14, 6],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [27, 153, 200],
    "s": [7, 7, 7],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 144, 202],
    "s": [3, 8, 4],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 140, 197],
    "s": [3, 8, 4],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [33, 144, 202],
    "s": [3, 8, 4],
    "l": 1,
    "r": [-0.35, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [33, 140, 197],
    "s": [3, 8, 4],
    "l": 1,
    "r": [0.7, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-351, 91, -112],
    "s": [70, 1, 300],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [115, 121, 208],
    "s": [32, 4, 32],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [27, 121, 208],
    "s": [32, 4, 32],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [393, 119, 164],
    "s": [220, 40, 220],
    "f": [0, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [519, 119, 76],
    "s": [30, 30, 30],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [393, 159, 164],
    "s": [180, 30, 180],
    "f": [0, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 219, 164],
    "s": [100, 30, 100],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 249, 164],
    "s": [50, 30, 50],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 159, 164],
    "s": [224, 4, 224],
    "f": [0, 1, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 189, 164],
    "s": [184, 4, 184],
    "f": [0, 1, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 219, 164],
    "s": [144, 4, 144],
    "f": [0, 1, 0, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 249, 164],
    "s": [104, 4, 104],
    "f": [1, 1, 0, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 279, 164],
    "s": [54, 4, 54],
    "f": [1, 1, 0, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [393, 119, 54],
    "s": [4, 40, 3],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [343, 119, 54],
    "s": [4, 40, 3],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [293, 119, 54],
    "s": [4, 40, 3],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [443, 119, 54],
    "s": [4, 40, 3],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [493, 119, 54],
    "s": [4, 40, 3],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [266, 149, 64],
    "s": [20, 8, 100],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [266, 139, 55],
    "s": [24, 4, 140],
    "f": [1, 0, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [266, 157, 72],
    "s": [24, 4, 100],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [281, 123, 76],
    "s": [20, 36, 22],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 1
  }, {
    "p": [215, 137, 63],
    "s": [76, 20, 160],
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [184, 157, -8],
    "s": [10, 22, 10],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [184, 157, 136],
    "s": [10, 30, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [184, 157, 100],
    "s": [10, 30, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [184, 157, 64],
    "s": [10, 30, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [184, 157, 28],
    "s": [10, 30, 10],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [223, 157, 75],
    "s": [56, 30, 132],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [215, 187, 75],
    "s": [76, 4, 136],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [215, 191, 75],
    "s": [72, 10, 132],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [215, 201, 75],
    "s": [76, 4, 136],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [186, 179, -5],
    "s": [6, 5, 4],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [181, 179, -6],
    "s": [4, 2, 6],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [223, 157, 3],
    "s": [56, 18, 12],
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [223, 162, -17],
    "s": [14, 26, 12],
    "r": [0.52, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [259, 150, -9],
    "s": [6, 12, 6],
    "r": [0, 0, 0.35],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [264, 149, -1],
    "s": [6, 2, 3],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [241, 132, 194],
    "s": [80, 28, 160],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-234, 59, -35],
    "s": [37, 52, 176],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-207, 105, -287],
    "s": [420, 40, 50],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [176, 137, -307],
    "s": [30, 30, 30],
    "r": [-3.14, 0, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [192, 137, 166],
    "s": [10, 30, 10],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [192, 137, 193],
    "s": [10, 42, 10],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [192, 137, 166],
    "s": [14, 4, 14],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [191, 179, 190],
    "s": [20, 4, 22],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [191, 183, 190],
    "s": [16, 10, 18],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [192, 137, 193],
    "s": [14, 4, 14],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [191, 193, 190],
    "s": [20, 4, 22],
    "f": [1, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [156, 109, 158],
    "s": [5, 3, 9],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [179, 137, 216],
    "s": [7, 5, 11],
    "r": [0, 0.7, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [1, 142, -315],
    "s": [24, 25, 24],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [8, 153, -333],
    "s": [28, 31, 30],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-147, 153, 45],
    "s": [12, 12, 12],
    "i": 8,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [539, 126, -80],
    "s": [30, 24, 20],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [539, 126, -3],
    "s": [30, 24, 20],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [539, 126, -42],
    "s": [30, 24, 20],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [554, 150, -61],
    "s": [60, 33, 136],
    "f": [0, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 126, -12],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 126, -34],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 150, -23],
    "s": [3, 4, 28],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 126, -50],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 126, -88],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 126, -110],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 126, -72],
    "s": [2, 24, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 150, -61],
    "s": [3, 4, 28],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [539, 126, -119],
    "s": [30, 24, 20],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [523, 150, -99],
    "s": [3, 4, 28],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [554, 180, -61],
    "s": [64, 4, 140],
    "f": [0, 1, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [554, 194, -61],
    "s": [64, 4, 140],
    "f": [0, 1, 0, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [533, 124, -188],
    "s": [30, 30, 30],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [562, 129, 10],
    "s": [51, 36, 36],
    "l": 1,
    "pe": 1,
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-66, 150, 212],
    "s": [88, 4, 66],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-99, 139, 62],
    "s": [22, 11, 14],
    "f": [0, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-99, 135, 66],
    "s": [22, 4, 6],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [31, 121, 133],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [126, 149, -154],
    "s": [80, 10, 134],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [311, 186, -147],
    "s": [50, 10, 60],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [413, 160, -202],
    "s": [200, 10, 50],
    "f": [0, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [480, 200, -289],
    "s": [120, 10, 100],
    "f": [0, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [554, 184, -61],
    "s": [60, 10, 136],
    "f": [0, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [266, 143, 53],
    "s": [20, 6, 140],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [344, 151, -71],
    "s": [50, 4, 96],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-28, 115, 32],
    "s": [6, 23, 2],
    "pe": 1,
    "c": "#818181",
    "t": 2
  }, {
    "p": [-17, 118, 32],
    "s": [28, 1, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-22, 115, 32],
    "s": [6, 22, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-17, 115, 32],
    "s": [4, 23, 1],
    "pe": 1,
    "c": "#707070",
    "t": 2
  }, {
    "p": [-12, 115, 32],
    "s": [6, 21, 2],
    "pe": 1,
    "c": "#7a7a7a",
    "t": 2
  }, {
    "p": [-7, 115, 32],
    "s": [7, 22, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [26, 149, -198],
    "s": [120, 10, 46],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [26, 159, -198],
    "s": [116, 4, 50],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [5, 97, -282],
    "s": [170, 58, 120],
    "f": [1, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [173, 116, -197],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-420, 140, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-411, 128, -37],
    "s": [50, 20, 12],
    "l": 1,
    "r": [0, 0, -0.69],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-424, 145, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-428, 150, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-416, 135, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-407, 135, -33],
    "s": [20, 26, 600],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 2
  }, {
    "p": [-370, 109, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-374, 114, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-378, 119, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-382, 124, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [110, 140, 200],
    "s": [3, 12, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-299, 81, -120],
    "s": [200, 10, 300],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [179, 116, -217],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [192, 116, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [209, 116, -191],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [212, 116, -216],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [226, 116, -208],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [193, 116, -187],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [240, 116, -190],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [255, 116, -217],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [280, 116, -203],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [261, 116, -196],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [293, 116, -189],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [301, 116, -219],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [272, 116, -187],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [233, 116, -194],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [251, 116, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [116, 160, 200],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [116, 162, 200],
    "s": [7, 4, 7],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [116, 166, 200],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [27, 160, 200],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [27, 162, 200],
    "s": [7, 4, 7],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [27, 166, 200],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [222, 137, -44],
    "s": [10, 14, 6],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [222, 151, -44],
    "s": [7, 7, 7],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [222, 158, -44],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [222, 160, -44],
    "s": [7, 4, 7],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [222, 164, -44],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [225, 123, -44],
    "s": [4, 14, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [219, 123, -44],
    "s": [4, 14, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [239, 109, -40],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [159, 110, -41],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [176, 110, -46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [155, 110, 116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [153, 110, 178],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [101, 110, 182],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [156, 110, 171],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [93, 110, 114],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [92, 110, 56],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [187, 144, -270],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [166, 144, -288],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [231, 144, -275],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [260, 144, -265],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [269, 144, -285],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 1.05, 0],
    "c": "#acdc56"
  }, {
    "p": [150, 144, -269],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [144, 144, -288],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [363, 123, -8],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [360, 123, 8],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [489, 123, 46],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [439, 123, 49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [337, 123, 51],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [156, 109, -1],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [30, 110, 190],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-20, 110, 189],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [165, 118, 38],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [161, 111, 77],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [176, 134, 135],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [171, 126, 221],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [146, 118, 219],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [157, 111, 207],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [183, 137, 185],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [208, 137, 246],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [236, 143, 180],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [227, 139, 221],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-47, 109, -30],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-133, 110, -55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-126, 110, -44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-195, 110, -64],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-204, 110, -40],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-157, 109, 44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-211, 110, 11],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-127, 110, 28],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-150, 110, 49],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-198, 110, -144],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-162, 81, -184],
    "s": [104, 28, 154],
    "f": [0, 1, 1, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-411, 128, -73],
    "s": [50, 20, 12],
    "l": 1,
    "r": [0, 0, -0.69],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-372, 106, -37],
    "s": [26, 20, 12],
    "l": 1,
    "r": [0, 0, -0.86],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-373, 106, -73],
    "s": [26, 20, 12],
    "l": 1,
    "r": [0, 0, -0.86],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-1, 116, 221],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-13, 113, 209],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [32, 114, 137],
    "s": [2, 3, 6],
    "l": 1,
    "c": "#5f5f5f",
    "t": 11
  }, {
    "p": [30, 114, 137],
    "s": [2, 3, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11
  }, {
    "p": [31, 115, 138],
    "s": [1, 1, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-186, 115, -157],
    "s": [2, 3, 6],
    "l": 1,
    "c": "#5f5f5f",
    "t": 11
  }, {
    "p": [-188, 115, -157],
    "s": [2, 3, 6],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11
  }, {
    "p": [-187, 116, -158],
    "s": [1, 1, 5],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-187, 109, -151],
    "s": [16, 16, 16],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-187, 111, -151],
    "s": [17, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-187, 122, -151],
    "s": [17, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-165, 109, -245],
    "s": [94, 1, 34],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-192, 109, -226],
    "s": [14, 16, 14],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-184, 109, -226],
    "s": [1, 50, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-164, 134, -230],
    "s": [42, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, -234],
    "s": [1, 47, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-144, 109, -226],
    "s": [1, 53, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-162, 109, -226],
    "s": [1, 51, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-162, 109, -234],
    "s": [1, 53, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-206, 109, -229],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-163, 109, -235],
    "s": [53, 32, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#1e798e",
    "t": 5
  }, {
    "p": [-190, 109, -235],
    "s": [1, 32, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-136, 109, -235],
    "s": [1, 32, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-163, 140, -240],
    "s": [55, 1, 2],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#505050",
    "t": 5
  }, {
    "p": [-185, 145, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-185, 140, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-143, 150, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-143, 145, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-143, 140, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-143, 117, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-143, 125, -230],
    "s": [1, 1, 10],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-179, 109, -230],
    "s": [9, 18, 9],
    "c": "#898989",
    "t": 11
  }, {
    "p": [-177, 135, -226],
    "s": [11, 9, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [96, 109, 64],
    "s": [12, 14, 10],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-303, 157, 186],
    "s": [124, 4, 64],
    "f": [1, 0, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-303, 161, 186],
    "s": [120, 10, 60],
    "f": [1, 0, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-303, 171, 186],
    "s": [124, 4, 64],
    "f": [1, 0, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-130, 109, -203],
    "s": [12, 12, 12],
    "i": 8
  }, {
    "p": [-363, 99, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-358, 94, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-353, 89, -55],
    "s": [40, 5, 24],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-8, 109, 209],
    "s": [1, 18, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-8, 118, 208],
    "s": [14, 8, 1],
    "pe": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [-132, 109, -190],
    "s": [14, 22, 14],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-132, 128, -190],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-132, 111, -190],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-176, 110, -221],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-202, 110, -218],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-129, 109, -171],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-368, 121, -223],
    "s": [100, 4, 204],
    "f": [1, 0, 1, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-368, 125, -223],
    "s": [96, 10, 200],
    "f": [1, 0, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-368, 135, -223],
    "s": [100, 4, 204],
    "f": [1, 0, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-368, 139, -223],
    "s": [100, 2, 204],
    "f": [1, 0, 1, 1, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-278, 161, -335],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-342, 129, -263],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-391, 134, -164],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-389, 131, -223],
    "s": [18, 21, 17],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-343, 128, -140],
    "s": [15, 18, 15],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-355, 132, -135],
    "s": [15, 18, 15],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-412, 138, -250],
    "s": [7, 50, 7],
    "pe": 1,
    "f": [1, 0, 0, 0, 1, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-412, 159, -250],
    "s": [54, 36, 54],
    "l": 1,
    "pe": 1,
    "f": [1, 0, 0, 1, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-325, 141, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-353, 141, -184],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-337, 141, -170],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-330, 141, -206],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-333, 141, -132],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-364, 141, -152],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-389, 141, -136],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-364, 141, -220],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-146, 127, -345],
    "s": [120, 30, 120],
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-146, 171, -345],
    "s": [80, 14, 80],
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-146, 185, -345],
    "s": [60, 14, 60],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-146, 199, -345],
    "s": [40, 14, 40],
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-146, 120, -276],
    "s": [20, 100, 40],
    "r": [-0.7, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-240, 185, -327],
    "s": [80, 46, 80],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-46, 127, -297],
    "s": [7, 80, 7],
    "pe": 1,
    "f": [1, 1, 0, 0, 1, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-386, 135, 29],
    "s": [10, 16, 10],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-218, 91, -138],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-223, 92, -162],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.79, 0],
    "c": "#acdc56"
  }, {
    "p": [-244, 92, -204],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-316, 92, -212],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-343, 92, -95],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-266, 91, -104],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.61, 3.14],
    "c": "#acdc56"
  }, {
    "p": [-258, 91, -33],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [-350, 110, 31],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-335, 110, 116],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-342, 110, 111],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-257, 108, 55],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-209, 109, 95],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-290, 110, 153],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-271, 109, 99],
    "s": [20, 13, 14],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-324, 110, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-279, 109, 99],
    "s": [1, 14, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-263, 109, 99],
    "s": [1, 14, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-285, 109, 98],
    "s": [8, 15, 8],
    "c": "#898989",
    "t": 11
  }, {
    "p": [-146, 157, -345],
    "s": [100, 14, 100],
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-392, 135, 148],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-382, 135, 127],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-392, 135, 108],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-387, 135, 101],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-377, 135, 78],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-379, 135, 37],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-387, 135, 21],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-388, 135, -29],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-378, 135, -56],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-379, 135, -7],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-393, 135, -83],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-377, 135, -118],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-205, 133, 191],
    "s": [8, 44, 8],
    "pe": 1,
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-205, 156, 191],
    "s": [56, 36, 56],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 1, 1, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-211, 135, 182],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-216, 135, 188],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-235, 135, 185],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-164, 59, 168],
    "s": [80, 90, 30],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [222, 109, -43],
    "s": [14, 12, 14],
    "f": [1, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [222, 121, -43],
    "s": [15, 2, 15],
    "f": [1, 1, 1, 1, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-21, 119, 226],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-129, 110, -234],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-210, 145, -293],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-170, 145, -281],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-140, 145, -269],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-104, 145, -270],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [114, 144, -275],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [367, 144, -269],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-363, 135, -342],
    "s": [160, 60, 100],
    "f": [1, 0, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-363, 195, -342],
    "s": [164, 4, 104],
    "f": [1, 0, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-363, 199, -342],
    "s": [160, 10, 100],
    "f": [1, 0, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-363, 209, -342],
    "s": [164, 4, 104],
    "f": [1, 0, 0, 1, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-281, 145, -288],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-260, 145, -281],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-235, 145, -270],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-267, 150, -329],
    "s": [18, 21, 21],
    "l": 1,
    "pe": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [393, 189, 164],
    "s": [140, 30, 140],
    "f": [0, 1, 0, 0, 0, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-91, 133, 27],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-88, 136, 27],
    "s": [5, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [215, 109, 123],
    "s": [76, 28, 260],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [396, 95, 93],
    "s": [257, 28, 100],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-232, 91, -184],
    "s": [36, 18, 34],
    "i": 9,
    "v": 1,
    "c": "#a7a793"
  }, {
    "p": [64, 57, -199],
    "s": [196, 88, 44],
    "f": [0, 0, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [8, 110, 196],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-14, 75, 110],
    "s": [4, 2, 23],
    "l": 1,
    "pe": 1,
    "r": [0, 0.61, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-117, 59, -85],
    "s": [14, 86, 76],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-41, 59, -85],
    "s": [14, 86, 76],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-123, 109, -35],
    "s": [24, 1, 4],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-39, 59, 7],
    "s": [10, 30, 60],
    "f": [1, 0, 0, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-163, 96, -265],
    "s": [45, 40, 50],
    "f": [1, 1, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-175, 136, -245],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-152, 136, -252],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "c": "#acdc56"
  }, {
    "p": [-143, 109, -188],
    "s": [6, 1, 32],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-102, 109, -271],
    "s": [44, 46, 100],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [227, 123, -47],
    "s": [5, 1, 7],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [230, 117, -46],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [230, 120, -50],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [230, 122, -48],
    "s": [1, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [230, 121, -45],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [215, 110, -42],
    "s": [1, 3, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [215, 110, -38],
    "s": [1, 8, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [215, 113, -40],
    "s": [1, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [215, 110, -46],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [215, 113, -42],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [364, 152, 21],
    "s": [6, 8, 6],
    "i": 2,
    "l": 1,
    "r": [0, -0.52, 0]
  }, {
    "p": [364, 123, 43],
    "s": [5, 1, 21],
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [369, 123, -11],
    "s": [4, 1, 29],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [129, 134, -138],
    "s": [16, 12, 16],
    "i": 32,
    "l": 1,
    "c": "#ffe9a6",
    "o": 0.5
  }, {
    "p": [-79, 135, -150],
    "s": [16, 10, 16],
    "i": 32,
    "l": 1,
    "c": "#ffe9a6",
    "o": 0.5
  }, {
    "p": [-79, 135, -82],
    "s": [16, 10, 16],
    "i": 32,
    "l": 1,
    "c": "#ffe9a6",
    "o": 0.5
  }, {
    "p": [-98, 125, 45],
    "s": [16, 11, 16],
    "i": 32,
    "l": 1,
    "c": "#ffe9a6",
    "o": 0.5
  }, {
    "p": [96, 109, 82],
    "s": [13, 15, 1],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [96, 109, 62],
    "s": [13, 15, 1],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-122, 109, -123],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-112, 109, -123],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 109, -153],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-112, 109, -153],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-79, 109, -199],
    "s": [62, 36, 44],
    "f": [0, 0, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-328, 145, -274],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-122, 144, -138],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-112, 144, -138],
    "s": [2, 2, 28],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-112, 141, -148],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 141, -148],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-112, 141, -128],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-122, 141, -128],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-114, 100, -138],
    "s": [1, 40, 32],
    "pe": 1,
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-289, 91, -231],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.17, 0],
    "c": "#acdc56"
  }, {
    "p": [-114, 114, -138],
    "s": [2, 4, 34],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-114, 127, -139],
    "s": [2, 5, 34],
    "l": 1,
    "r": [0.35, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-315, 91, -205],
    "s": [1, 26, 4],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-317, 91, -198],
    "s": [1, 15, 5],
    "l": 1,
    "r": [0, 0, 0.17],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-317, 91, -190],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-316, 91, -157],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-296, 92, -220],
    "s": [3, 1, 17],
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-477, 135, -55],
    "s": [120, 26, 600],
    "f": [0, 0, 1, 0, 0, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [325, 117, -117],
    "s": [6, 20, 2],
    "f": [0, 1, 0, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [333, 117, -116],
    "s": [6, 20, 2],
    "f": [1, 0, 0, 0, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-303, 136, 154],
    "s": [66, 0, 31],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 3.14],
    "sad": 1
  }, {
    "p": [-303, 119, 158],
    "s": [71, 34, 6],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 1, 1, 0, 1],
    "c": "#39291f",
    "t": 5
  }, {
    "p": [164, 181, -133],
    "s": [59, 0, 26],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [162, 166, -133],
    "s": [2, 30, 64],
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [-317, 91, -124],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [27, 182, 27],
    "s": [64, 0, 28],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 0],
    "sad": 1
  }, {
    "p": [27, 165, 25],
    "s": [71, 34, 2],
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [57, 161, 22],
    "s": [4, 41, 4],
    "l": 1,
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [-1, 161, 22],
    "s": [4, 41, 4],
    "l": 1,
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [95, 109, 98],
    "s": [5, 3, 9],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [154, 109, 10],
    "s": [5, 3, 9],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-16, 109, 194],
    "s": [6, 3, 6],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [36, 109, 181],
    "s": [5, 3, 9],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-28, 58, 23],
    "s": [5, 3, 9],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [80, 58, -62],
    "s": [5, 3, 9],
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [71, 75, -62],
    "s": [4, 2, 23],
    "l": 1,
    "pe": 1,
    "r": [0, 0.17, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-17, 75, -48],
    "s": [4, 2, 23],
    "l": 1,
    "pe": 1,
    "r": [0, -0.62, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [37, 58, -62],
    "s": [6, 4, 6],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [12, 51, 20],
    "s": [6, 4, 6],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [7, 51, 121],
    "s": [6, 4, 6],
    "l": 1,
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-220, 185, -19],
    "s": [57, 0, 25],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 1.57],
    "sad": 1
  }, {
    "p": [-222, 171, -19],
    "s": [2, 28, 62],
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [-225, 161, 6],
    "s": [4, 41, 4],
    "l": 1,
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [-225, 161, -44],
    "s": [4, 41, 4],
    "l": 1,
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [41, 109, -13],
    "s": [4, 21, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [34, 109, -13],
    "s": [4, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [98, 109, -14],
    "s": [4, 18, 1],
    "l": 1,
    "r": [-0.17, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-109, 110, 25],
    "s": [4, 18, 1],
    "l": 1,
    "r": [0.18, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-20, 109, 131],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [234, 109, -81],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [0, 0.78, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-42, 109, -16],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [2, 109, -16],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-42, 136, -11],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [2, 136, -11],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [2, 109, 18],
    "s": [14, 22, 14],
    "c": "#ffffff",
    "t": 2,
    "bo": 1
  }, {
    "p": [2, 128, 18],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [2, 111, 18],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-14, 109, 19],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [-3.14, 0.88, -3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [82, 109, -16],
    "s": [2, 36, 2],
    "l": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [82, 136, -11],
    "s": [1, 2, 12],
    "l": 1,
    "pe": 1,
    "r": [-0.7, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-105, 114, -67],
    "s": [4, 3, 7],
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-51, 114, -153],
    "s": [3, 3, 7],
    "l": 1,
    "r": [0, 0.44, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-58, 116, -167],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [0.01, 1.3, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-102, 116, -150],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [-3.13, -0.17, 3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-79, 112, -104],
    "s": [18, 19, 16],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-79, 117, -104],
    "s": [19, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-79, 128, -104],
    "s": [19, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [169, 117, -196],
    "s": [1, 46, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [196, 117, -196],
    "s": [1, 46, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [196, 117, -183],
    "s": [1, 46, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [169, 117, -183],
    "s": [1, 46, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [183, 152, -189],
    "s": [30, 1, 16],
    "pe": 1,
    "c": "#505050",
    "t": 2,
    "bo": 1
  }, {
    "p": [182, 141, -189],
    "s": [30, 1, 16],
    "pe": 1,
    "c": "#505050",
    "t": 2,
    "bo": 1
  }, {
    "p": [-167, 109, -162],
    "s": [80, 49, 105],
    "i": 14,
    "l": 1
  }, {
    "p": [103, 114, -174],
    "s": [3, 3, 7],
    "l": 1,
    "r": [0, -0.43, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [157, 114, -105],
    "s": [3, 3, 7],
    "l": 1,
    "r": [0, -0.69, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [106, 115, -108],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [0, 0.78, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [209, 109, -82],
    "s": [4, 2, 7],
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [280, 109, 26],
    "s": [1, 19, 3],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.17],
    "c": "#505050",
    "t": 2
  }, {
    "p": [279, 109, 20],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [318, 128, 49],
    "s": [14, 8, 1],
    "pe": 1,
    "c": "#ffffff",
    "t": 5
  }, {
    "p": [318, 119, 50],
    "s": [1, 18, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [238, 116, -209],
    "s": [16, 16, 16],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-79, 121, -96],
    "s": [4, 3, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11
  }, {
    "p": [-78, 122, -95],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [159, 162, -110],
    "s": [4, 38, 4],
    "l": 1,
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [159, 162, -160],
    "s": [4, 38, 4],
    "l": 1,
    "pe": 1,
    "c": "#39291f",
    "t": 5
  }, {
    "p": [171, 119, -137],
    "s": [11, 1, 43],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [175, 120, -117],
    "s": [1, 20, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [175, 120, -157],
    "s": [1, 19, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [171, 137, -137],
    "s": [11, 1, 43],
    "pe": 1,
    "c": "#505050",
    "t": 2,
    "bo": 1
  }, {
    "p": [164, 112, -157],
    "s": [1, 14, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.96],
    "c": "#505050",
    "t": 2
  }, {
    "p": [164, 112, -117],
    "s": [1, 14, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.96],
    "c": "#505050",
    "t": 2
  }, {
    "p": [238, 115, -85],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [236, 112, -87],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [236, 111, -83],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [238, 114, -85],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [236, 114, -85],
    "s": [1, 1, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [524, 129, -99],
    "s": [3, 22, 18],
    "l": 1,
    "c": "#7a7a7a",
    "t": 2
  }, {
    "p": [238, 128, -209],
    "s": [17, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [280, 109, -9],
    "s": [4, 2, 7],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-273, 116, 92],
    "s": [4, 3, 2],
    "l": 1,
    "c": "#8e8e8e",
    "t": 11
  }, {
    "p": [-274, 117, 91],
    "s": [1, 1, 1],
    "l": 1,
    "c": "#ff0000",
    "e": "#ff0000",
    "t": 5
  }, {
    "p": [-324, 92, 6],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-258, 92, 9],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [-332, 91, -41],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.17, -3.14],
    "c": "#acdc56"
  }, {
    "p": [15, 109, 132],
    "s": [6, 2, 3],
    "l": 1,
    "r": [-3.14, 0.7, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [42, 109, 177],
    "s": [24, 1, 12],
    "l": 1,
    "f": [1, 1, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [41, 110, 179],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#acdc56"
  }, {
    "p": [-20, 58, 91],
    "s": [4, 2, 7],
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [105, 110, 63],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.05, 0],
    "c": "#acdc56"
  }, {
    "p": [272, 118, -179],
    "s": [49, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [249, 113, -177],
    "s": [2, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [249, 108, -177],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [254, 116, -177],
    "s": [8, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [251, 114, -177],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [255, 115, -177],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [170, 118, -179],
    "s": [13, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [175, 113, -177],
    "s": [2, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [175, 108, -177],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [170, 116, -177],
    "s": [8, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [173, 114, -177],
    "s": [2, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-208, 109, 88],
    "s": [1, 19, 3],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.18],
    "c": "#505050",
    "t": 2
  }, {
    "p": [524, 129, -24],
    "s": [3, 22, 18],
    "l": 1,
    "c": "#7a7a7a",
    "t": 2
  }, {
    "p": [524, 129, -61],
    "s": [3, 22, 18],
    "l": 1,
    "c": "#7a7a7a",
    "t": 2
  }, {
    "p": [102, 109, -81],
    "s": [26, 1, 52],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [109, 108, -61],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.61, 3.14],
    "c": "#acdc56"
  }, {
    "p": [157, 109, 1],
    "s": [26, 1, 52],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [156, 109, 36],
    "s": [16, 1, 18],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-74, 109, 138],
    "s": [36, 1, 48],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-85, 109, 156],
    "s": [4, 3, 7],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-82, 110, 151],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 1.39, -3.14],
    "c": "#acdc56"
  }, {
    "p": [-64, 110, 119],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#acdc56"
  }, {
    "p": [-74, 109, 112],
    "s": [25, 1, 4],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-71, 109, 164],
    "s": [25, 1, 4],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-60, 110, 159],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.43, -3.14],
    "c": "#acdc56"
  }, {
    "p": [-62, 110, 123],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#f9fcbd"
  }, {
    "p": [-62, 112, 123],
    "s": [3, 2, 3],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#8e6849"
  }, {
    "p": [-87, 109, 119],
    "s": [2, 2, 3],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-86, 109, 123],
    "s": [3, 3, 4],
    "l": 1,
    "r": [-3.14, 1.22, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-73, 109, 76],
    "s": [14, 22, 14],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-73, 128, 76],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-73, 111, 76],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-180, 109, 96],
    "s": [4, 2, 6],
    "l": 1,
    "r": [-3.14, 0.96, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-95, 109, 176],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [0, 1.39, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-176, 109, 146],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [0, 0.78, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-226, 116, 160],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-0.35, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [-245, 108, 76],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.09, 0],
    "c": "#acdc56"
  }, {
    "p": [-272, 109, 87],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.13, 0],
    "c": "#acdc56"
  }, {
    "p": [-320, 91, 9],
    "s": [4, 17, 1],
    "l": 1,
    "r": [0.18, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-325, 91, 10],
    "s": [4, 13, 1],
    "l": 1,
    "r": [0.18, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-279, 91, 0],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.35, -3.14],
    "c": "#acdc56"
  }, {
    "p": [-216, 91, -214],
    "s": [1, 17, 4],
    "l": 1,
    "r": [0, 0, -0.09],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-220, 91, -206],
    "s": [11, 14, 9],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-220, 94, -206],
    "s": [12, 1, 10],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-220, 102, -206],
    "s": [12, 1, 10],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-216, 91, -164],
    "s": [1, 17, 4],
    "l": 1,
    "r": [0, 0, -0.09],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-276, 91, 8],
    "s": [11, 14, 9],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-276, 102, 8],
    "s": [12, 1, 10],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-276, 94, 8],
    "s": [12, 1, 10],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-218, 91, -156],
    "s": [7, 9, 10],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-218, 98, -156],
    "s": [8, 1, 11],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-218, 93, -156],
    "s": [8, 1, 11],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-218, 100, -158],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-276, 92, -162],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.26, 0],
    "c": "#acdc56"
  }, {
    "p": [-129, 109, 148],
    "s": [3, 2, 6],
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-258, 92, -121],
    "s": [3, 2, 6],
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-278, 92, -155],
    "s": [2, 1, 4],
    "l": 1,
    "r": [0.01, 1.23, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-313, 91, -155],
    "s": [6, 1, 92],
    "l": 1,
    "f": [1, 0, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-333, 92, -72],
    "s": [3, 2, 6],
    "l": 1,
    "r": [0, 0.97, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-153, 109, 121],
    "s": [40, 1, 40],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-137, 109, 138],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#acdc56"
  }, {
    "p": [-168, 109, 136],
    "s": [3, 2, 4],
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-167, 110, 108],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.69, 0],
    "c": "#acdc56"
  }, {
    "p": [138, 115, -170],
    "s": [14, 16, 14],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [138, 128, -170],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [138, 117, -170],
    "s": [15, 1, 15],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [96, 107, 77],
    "s": [12, 16, 16],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-337, 91, -120],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [-345, 91, 10],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [-211, 109, 48],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.44, 3.14],
    "c": "#acdc56"
  }, {
    "p": [190, 118, -179],
    "s": [14, 2, 4],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [229, 118, -179],
    "s": [20, 2, 4],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [136, 58, -94],
    "s": [5, 3, 9],
    "l": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [89, 75, -169],
    "s": [4, 2, 15],
    "l": 1,
    "pe": 1,
    "r": [0, 1.04, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [152, 75, -98],
    "s": [4, 2, 15],
    "l": 1,
    "pe": 1,
    "r": [0, 0.69, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [157, 54, -158],
    "s": [4, 3, 6],
    "l": 1,
    "r": [-2.97, 0, 3.12],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-39, 109, 46],
    "s": [10, 6, 18],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-39, 115, 53],
    "s": [1, 22, 5],
    "pe": 1,
    "c": "#777777",
    "t": 2
  }, {
    "p": [-39, 115, 38],
    "s": [2, 20, 5],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-39, 115, 43],
    "s": [1, 21, 5],
    "pe": 1,
    "c": "#868686",
    "t": 2
  }, {
    "p": [-39, 115, 48],
    "s": [2, 20, 5],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-39, 118, 45],
    "s": [3, 1, 20],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-39, 132, 45],
    "s": [3, 1, 20],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-48, 109, 46],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [-3.14, -0.08, -3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-17, 133, 32],
    "s": [28, 1, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-333, 110, 52],
    "s": [3, 2, 6],
    "l": 1,
    "r": [-3.14, 1.12, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-327, 110, 56],
    "s": [2, 1, 4],
    "l": 1,
    "r": [0.01, 1.24, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-279, 92, -48],
    "s": [2, 1, 4],
    "l": 1,
    "r": [0.01, 1.23, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-278, 91, -82],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.87, 0],
    "c": "#acdc56"
  }, {
    "p": [-129, 108, -112],
    "s": [3, 2, 6],
    "l": 1,
    "r": [-3.14, 0.78, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-50, 109, -41],
    "s": [3, 2, 6],
    "l": 1,
    "r": [-3.14, -0.44, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [160, 115, -146],
    "s": [1, 19, 3],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.09],
    "c": "#505050",
    "t": 2
  }, {
    "p": [160, 115, -141],
    "s": [1, 11, 3],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.18],
    "c": "#505050",
    "t": 2
  }, {
    "p": [280, 109, 11],
    "s": [14, 1, 64],
    "l": 1,
    "f": [1, 0, 1, 0, 0, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [282, 109, -15],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [281, 109, 12],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.7, 0],
    "c": "#acdc56"
  }, {
    "p": [318, 109, -31],
    "s": [3, 2, 5],
    "l": 1,
    "r": [0, 0.09, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [158, 59, -176],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [158, 59, -88],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [121, 59, -88],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [121, 59, -176],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [90, 59, -176],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [90, 59, -98],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [90, 82, -98],
    "s": [2, 15, 2],
    "l": 1,
    "r": [-0.87, 0, 0],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [121, 82, -88],
    "s": [2, 15, 2],
    "l": 1,
    "r": [-0.87, 0, 0],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [158, 82, -88],
    "s": [2, 15, 2],
    "l": 1,
    "r": [-0.87, 0, 0],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [158, 82, -176],
    "s": [2, 15, 2],
    "l": 1,
    "r": [0.79, 0, 0],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [121, 82, -176],
    "s": [2, 15, 2],
    "l": 1,
    "r": [0.79, 0, 0],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [90, 82, -176],
    "s": [2, 15, 2],
    "l": 1,
    "r": [0.79, 0, 0],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [272, 116, -201],
    "s": [14, 4, 14],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [272, 118, -201],
    "s": [10, 23, 9],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [358, 158, -109],
    "s": [9, 17, 9],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [358, 155, -109],
    "s": [12, 3, 11],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [25, 133, -26],
    "s": [66, 0, 31],
    "i": 11,
    "l": 1,
    "r": [1.57, 0, 3.14],
    "sad": 1
  }, {
    "p": [25, 116, -22],
    "s": [71, 34, 6],
    "l": 1,
    "pe": 1,
    "f": [1, 1, 1, 1, 0, 1],
    "c": "#39291f",
    "t": 5
  }, {
    "p": [55, 150, -24],
    "s": [13, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [35, 150, -24],
    "s": [9, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-4, 150, -24],
    "s": [15, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [61, 142, -24],
    "s": [1, 8, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [57, 144, -25],
    "s": [1, 6, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [59, 147, -25],
    "s": [3, 3, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [31, 144, -25],
    "s": [1, 6, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [38, 147, -25],
    "s": [3, 3, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [34, 149, -25],
    "s": [6, 1, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-2, 148, -25],
    "s": [6, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-8, 147, -25],
    "s": [6, 3, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-11, 142, -25],
    "s": [1, 8, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-3, 144, -25],
    "s": [1, 4, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [21, 57, -88],
    "s": [10, 22, 10],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [21, 58, -88],
    "s": [13, 5, 12],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [19, 79, -86],
    "s": [6, 2, 6],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [11, 58, -77],
    "s": [4, 3, 5],
    "l": 1,
    "r": [0, 0.7, 0],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [33, 58, -95],
    "s": [4, 3, 8],
    "l": 1,
    "r": [0, 0.35, 0],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [24, 78, -88],
    "s": [5, 2, 11],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [26, 72, -93],
    "s": [1, 6, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [26, 74, -83],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [26, 76, -86],
    "s": [1, 2, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [25, 77, -83],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-273, 119, -95],
    "s": [10, 14, 6],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-273, 133, -95],
    "s": [7, 7, 7],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-279, 120, -95],
    "s": [3, 12, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-273, 140, -95],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-273, 142, -95],
    "s": [7, 4, 7],
    "c": "#7d7d61",
    "e": "#282828",
    "t": 11
  }, {
    "p": [-273, 146, -95],
    "s": [8, 2, 8],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-270, 105, -95],
    "s": [4, 14, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-276, 105, -95],
    "s": [4, 14, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-267, 120, -95],
    "s": [3, 12, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [-273, 91, -94],
    "s": [14, 12, 14],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-273, 103, -94],
    "s": [15, 2, 15],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-268, 105, -98],
    "s": [5, 1, 7],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-265, 99, -97],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-265, 102, -101],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-265, 104, -99],
    "s": [1, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-265, 103, -96],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-280, 92, -93],
    "s": [1, 3, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-280, 92, -89],
    "s": [1, 8, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-280, 95, -91],
    "s": [1, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-280, 92, -97],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [-280, 95, -93],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [273, 59, -102],
    "s": [33, 27, 30],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [282, 86, -115],
    "s": [9, 4, 4],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [286, 86, -101],
    "s": [2, 23, 8],
    "i": 3,
    "c": "#505050",
    "t": 2,
    "d": 2
  }, {
    "p": [284, 115, -85],
    "s": [5, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [285, 114, -85],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [286, 111, -83],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [286, 112, -87],
    "s": [1, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [313, 109, -112],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [0, 1.39, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-300, 109, 86],
    "s": [94, 49, 131],
    "i": 14,
    "l": 1
  }, {
    "p": [97, 152, -60],
    "s": [2, 9, 8],
    "i": 3,
    "v": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [338, 109, 8],
    "s": [32, 14, 70],
    "i": 9,
    "c": "#467532",
    "t": 1
  }, {
    "p": [304, 109, 36],
    "s": [100, 14, 14],
    "i": 9,
    "c": "#467532",
    "t": 1,
    "d": 1
  }, {
    "p": [368, 123, -22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [361, 122, 37],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.4, 0],
    "c": "#acdc56"
  }, {
    "p": [337, 114, 28],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.31, -3.14],
    "c": "#acdc56"
  }, {
    "p": [322, 109, -1],
    "s": [14, 1, 73],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [301, 109, 26],
    "s": [28, 1, 9],
    "l": 1,
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#467532",
    "t": 1
  }, {
    "p": [320, 109, -22],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -1.39, 0],
    "c": "#acdc56"
  }, {
    "p": [317, 109, -104],
    "s": [3, 2, 5],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [137, 109, -42],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [-3.14, 1.05, -3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [289, 56, -166],
    "s": [3, 33, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [289, 56, -128],
    "s": [3, 33, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [320, 56, -128],
    "s": [3, 33, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [320, 56, -166],
    "s": [3, 33, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [289, 82, -166],
    "s": [2, 15, 2],
    "l": 1,
    "r": [0.79, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [320, 82, -166],
    "s": [2, 15, 2],
    "l": 1,
    "r": [0.79, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [289, 82, -127],
    "s": [2, 15, 2],
    "l": 1,
    "r": [-0.87, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [320, 82, -127],
    "s": [2, 15, 2],
    "l": 1,
    "r": [-0.87, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [286, 140, -146],
    "s": [22, 18, 17],
    "f": [1, 1, 0, 1, 1, 0],
    "c": "#0b0b0b",
    "t": 5
  }, {
    "p": [282, 137, -146],
    "s": [12, 24, 23],
    "c": "#66664e",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [274, 137, -136],
    "s": [4, 24, 3],
    "c": "#66664e",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [274, 137, -156],
    "s": [4, 24, 3],
    "c": "#66664e",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [274, 137, -146],
    "s": [4, 3, 17],
    "c": "#66664e",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [274, 158, -146],
    "s": [4, 3, 17],
    "c": "#66664e",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [270, 76, -146],
    "s": [4, 66, 17],
    "l": 1,
    "c": "#668b6b",
    "e": "#0b130d",
    "o": 0.9,
    "t": 2,
    "ts": 12,
    "td": 1
  }, {
    "p": [280, 90, -115],
    "s": [6, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [277, 84, -117],
    "s": [1, 7, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [277, 87, -113],
    "s": [1, 4, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [173, 120, -117],
    "s": [9, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [177, 115, -115],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [177, 119, -117],
    "s": [1, 1, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [175, 119, -115],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [173, 117, -115],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [177, 118, -119],
    "s": [1, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [173, 138, -157],
    "s": [9, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [177, 133, -159],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [177, 136, -155],
    "s": [1, 2, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [70, 115, 32],
    "s": [7, 22, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [53, 115, 32],
    "s": [4, 23, 1],
    "pe": 1,
    "c": "#7f7f7f",
    "t": 2
  }, {
    "p": [64, 115, 32],
    "s": [6, 21, 2],
    "pe": 1,
    "c": "#8e8e8e",
    "t": 2
  }, {
    "p": [48, 115, 32],
    "s": [6, 22, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [58, 115, 32],
    "s": [6, 22, 1],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [59, 118, 32],
    "s": [28, 1, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [59, 133, 32],
    "s": [28, 1, 3],
    "pe": 1,
    "c": "#757575",
    "t": 2
  }, {
    "p": [319, 109, -97],
    "s": [1, 17, 3],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.09],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-55, 115, -71],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [-3.13, 0.44, 3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [224, 59, -179],
    "s": [124, 59, 4],
    "f": [0, 0, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [278, 89, -116],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [283, 88, -117],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [262, 86, -111],
    "s": [3, 2, 4],
    "l": 1,
    "r": [-3.14, 0.79, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [259, 86, -115],
    "s": [6, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [256, 82, -117],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [256, 84, -113],
    "s": [1, 3, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [257, 85, -116],
    "s": [3, 2, 3],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [264, 86, -94],
    "s": [4, 1, 13],
    "l": 1,
    "pe": 1,
    "r": [3.14, -0.95, 3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [247, 57, -98],
    "s": [8, 7, 10],
    "l": 1,
    "r": [-3.14, 0.44, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [170, 75, -169],
    "s": [3, 2, 24],
    "l": 1,
    "pe": 1,
    "r": [-3.14, 1.14, 3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [246, 75, -116],
    "s": [4, 2, 13],
    "l": 1,
    "pe": 1,
    "r": [-3.14, 1.15, -3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-14, 58, 115],
    "s": [8, 5, 7],
    "l": 1,
    "r": [0, 0.27, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [78, 58, 61],
    "s": [10, 7, 13],
    "l": 1,
    "r": [-0.01, 0.02, -0.07],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [47, 109, 131],
    "s": [6, 3, 4],
    "l": 1,
    "r": [-3.14, -0.61, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-20, 109, 125],
    "s": [9, 6, 4],
    "f": [1, 0, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [83, 109, 125],
    "s": [6, 6, 4],
    "f": [0, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [40, 58, 117],
    "s": [10, 7, 13],
    "l": 1,
    "r": [0.03, -1.11, 0.04],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [80, 58, 73],
    "s": [4, 2, 7],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [85, 59, -15],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-33, 59, 33],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [85, 59, 9],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-33, 59, 9],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-33, 59, -15],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [85, 59, 33],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [85, 83, -15],
    "s": [2, 11, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.79],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [85, 83, 33],
    "s": [2, 12, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.79],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [85, 83, 9],
    "s": [2, 10, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.79],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-33, 83, 33],
    "s": [2, 12, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.78],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-33, 83, 9],
    "s": [2, 12, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.78],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-33, 83, -15],
    "s": [2, 12, 2],
    "l": 1,
    "pe": 1,
    "r": [0, 0, -0.78],
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-10, 75, -66],
    "s": [4, 2, 23],
    "l": 1,
    "pe": 1,
    "r": [0, 0.61, 0],
    "c": "#434343",
    "t": 2
  }, {
    "p": [-22, 58, -166],
    "s": [10, 7, 13],
    "l": 1,
    "r": [-0.05, -0.5, -0.08],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [274, 56, -165],
    "s": [10, 7, 13],
    "l": 1,
    "r": [2.97, -0.89, 2.98],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [185, 58, -94],
    "s": [5, 3, 9],
    "l": 1,
    "r": [0, 1.04, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [196, 58, -93],
    "s": [3, 3, 4],
    "l": 1,
    "r": [0, -0.09, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [171, 58, -166],
    "s": [8, 3, 10],
    "l": 1,
    "r": [0, 0.61, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [29, 63, 77],
    "s": [10, 20, 10],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [27, 83, 79],
    "s": [6, 2, 6],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [29, 58, 77],
    "s": [13, 5, 12],
    "f": [1, 1, 1, 0, 1, 1],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [40, 58, 84],
    "s": [5, 3, 8],
    "l": 1,
    "r": [0, -0.35, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [59, 56, 3],
    "s": [10, 7, 13],
    "l": 1,
    "r": [-0.35, -1.36, -0.35],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-157, 109, -12],
    "s": [16, 16, 16],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [-157, 122, -12],
    "s": [17, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-157, 111, -12],
    "s": [17, 1, 17],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [-37, 109, -17],
    "s": [28, 1, 16],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#467532",
    "t": 1
  }, {
    "p": [-37, 109, -13],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, -0.52, 0],
    "c": "#acdc56"
  }, {
    "p": [101, 109, -81],
    "s": [11, 14, 12],
    "c": "#ffffff",
    "t": 2
  }, {
    "p": [101, 120, -81],
    "s": [12, 1, 13],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [101, 112, -81],
    "s": [12, 1, 13],
    "l": 1,
    "c": "#393939",
    "t": 5
  }, {
    "p": [112, 109, -82],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0.79, 0],
    "c": "#acdc56"
  }, {
    "p": [-224, 109, -235],
    "s": [7, 2, 2],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-296, 109, -235],
    "s": [12, 2, 2],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-258, 109, -235],
    "s": [13, 1, 2],
    "l": 1,
    "f": [1, 1, 1, 0, 1, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-168, 109, 112],
    "s": [1, 3, 1],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#f9fcbd"
  }, {
    "p": [-168, 112, 112],
    "s": [3, 2, 3],
    "l": 1,
    "r": [0, 0.96, 0],
    "c": "#8e6849"
  }, {
    "p": [201, 109, -44],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [3.14, -0.44, 3.14],
    "c": "#acdc56"
  }, {
    "p": [152, 108, 39],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [-3.14, -1.4, -3.14],
    "c": "#acdc56"
  }, {
    "p": [-217, 115, -16],
    "s": [1, 3, 22],
    "l": 1,
    "r": [0.09, 0, 0],
    "c": "#acacac",
    "t": 2
  }, {
    "p": [-217, 121, -16],
    "s": [1, 4, 26],
    "l": 1,
    "c": "#cacaca",
    "t": 2
  }, {
    "p": [-220, 111, -16],
    "s": [1, 25, 19],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [-217, 128, -16],
    "s": [1, 3, 22],
    "l": 1,
    "c": "#a9a9a9",
    "t": 2
  }, {
    "p": [-220, 111, 21],
    "s": [1, 25, 19],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [-220, 111, -54],
    "s": [1, 25, 19],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [-218, 111, -48],
    "s": [2, 2, 4],
    "l": 1,
    "r": [0, 0.35, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-213, 109, -64],
    "s": [3, 3, 5],
    "l": 1,
    "r": [0, -0.26, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [-211, 109, -42],
    "s": [4, 3, 6],
    "l": 1,
    "r": [0, -0.26, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [76, 75, 34],
    "s": [4, 2, 23],
    "l": 1,
    "pe": 1,
    "r": [0, -0.35, 0],
    "c": "#757575",
    "t": 2
  }, {
    "p": [75, 75, 110],
    "s": [4, 2, 15],
    "l": 1,
    "pe": 1,
    "r": [0, -0.18, 0],
    "c": "#7f7f7f",
    "t": 2
  }, {
    "p": [32, 82, 77],
    "s": [5, 2, 11],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [34, 80, 80],
    "s": [1, 2, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [34, 77, 72],
    "s": [1, 5, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [31, 81, 82],
    "s": [3, 1, 1],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [33, 81, 74],
    "s": [3, 1, 5],
    "l": 1,
    "c": "#467532",
    "t": 1
  }, {
    "p": [32, 58, 63],
    "s": [4, 2, 7],
    "l": 1,
    "r": [0, 1.22, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [18, 57, 86],
    "s": [6, 3, 8],
    "l": 1,
    "r": [-3.14, -0.61, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [5, 75, 53],
    "s": [4, 2, 15],
    "l": 1,
    "pe": 1,
    "r": [-3.14, 0.96, -3.14],
    "c": "#757575",
    "t": 2
  }, {
    "p": [-109, 109, 66],
    "s": [2, 27, 2],
    "l": 1,
    "f": [1, 1, 0, 0, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-106, 132, 66],
    "s": [12, 2, 1],
    "l": 1,
    "pe": 1,
    "r": [0, 0, 0.7],
    "f": [0, 0, 1, 1, 1, 1],
    "c": "#505050",
    "t": 2
  }, {
    "p": [-143, 109, -230],
    "s": [2, 42, 8],
    "i": 3,
    "v": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [-185, 125, -230],
    "s": [2, 27, 8],
    "i": 3,
    "v": 1,
    "c": "#505050",
    "t": 2,
    "d": 2
  }, {
    "p": [-179, 135, -231],
    "s": [6, 8, 6],
    "i": 2
  }, {
    "p": [-177, 135, -227],
    "s": [11, 9, 2],
    "pe": 1,
    "v": 1,
    "c": "#ffffff"
  }, {
    "p": [88, 109, 132],
    "s": [5, 3, 9],
    "l": 1,
    "r": [-3.14, 1.22, -3.14],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [97, 145, -60],
    "s": [1, 2, 10],
    "l": 1,
    "r": [0.17, 0, 0],
    "c": "#505050",
    "t": 2
  }, {
    "p": [105, 109, -68],
    "s": [3, 2, 10],
    "l": 1,
    "pe": 1,
    "r": [-3.14, 0.44, -3.14],
    "c": "#505050",
    "t": 2
  }, {
    "p": [59, 138, 8],
    "s": [4, 1, 3],
    "l": 1,
    "c": "#000000",
    "t": 5
  }, {
    "p": [59, 129, 8],
    "s": [16, 10, 16],
    "i": 32,
    "l": 1,
    "c": "#ffe9a6",
    "o": 0.5
  }, {
    "p": [59, 137, 8],
    "s": [3, 1, 2],
    "l": 1,
    "c": "#000000",
    "e": "#ffe9a6",
    "t": 5
  }, {
    "p": [-7, 107, 203],
    "s": [37, 3, 4],
    "c": "#ffffff",
    "e": "#282828",
    "t": 5,
    "bo": 1
  }, {
    "p": [115, 108, 208],
    "s": [32, 1, 33],
    "c": "#ffffff",
    "bo": 1
  }, {
    "p": [216, 148, -44],
    "s": [3, 8, 4],
    "l": 1,
    "r": [-0.69, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [216, 152, -49],
    "s": [3, 8, 4],
    "l": 1,
    "r": [0.01, 0, 0],
    "c": "#7d7d61",
    "e": "#282828"
  }, {
    "p": [228, 138, -44],
    "s": [3, 12, 4],
    "c": "#7d7d61",
    "e": "#282828",
    "bo": 1
  }, {
    "p": [1, 59, -15],
    "s": [3, 26, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [46, 59, -15],
    "s": [3, 31, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [0, 59, 33],
    "s": [3, 30, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [45, 59, 33],
    "s": [3, 20, 3],
    "pe": 1,
    "c": "#505050",
    "t": 2
  }, {
    "p": [175, 134, -9],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0, 0.09],
    "c": "#acdc56"
  }, {
    "p": [175, 132, 69],
    "s": [7, 6, 8],
    "i": 18,
    "l": 1,
    "r": [0, 0, 0.26],
    "c": "#acdc56"
  }]
}